// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"156":"806f7815","494":"4e24a03c","527":"c9ce5ac8","805":"7c71a21a"}[chunkId] + ".css";
};